const ERRORS = {
  bridge:
    'Could not connect to payment provider. Please contact customer support.',
  terms: 'Subscription and payment terms must be accepted',
  generic:
    'Payment failed. Please check your card details or contact customer support.',
  field_invalid_card_number: 'Invalid card number',
  field_invalid_card_number_dankort:
    'Unfortunately we do not support Dankort. Please use a Visa, Visa/Dankort or MasterCard',
  field_invalid_card_number_luhn:
    'It looks like you have typed a wrong credit card number',
  field_invalid_card_cvc: 'Invalid CVC',
  field_invalid_card_exp: 'Invalid expire date, or credit card has expired',
  field_invalid_card_name: 'Please enter the card holder name',
  failed_3ds: 'Payment failed. Please try again, or contact customer support.'
};

const ERROR_CODES = new Map([
  // Paylike
  [2, ERRORS.generic],
  [3, ERRORS.field_invalid_card_number],
  [4, ERRORS.field_invalid_card_cvc],
  [5, ERRORS.field_invalid_card_exp],
  [6, ERRORS.field_invalid_card_exp],
  [7, 'Payment was unsuccessful, since the credit card limit was exceeded'],
  [17, ERRORS.field_invalid_card_number],
  [18, ERRORS.field_invalid_card_exp],
  [19, ERRORS.field_invalid_card_exp],
  [20, ERRORS.field_invalid_card_cvc],
  [25, 'Payment was unsuccessful, since the credit card limit was exceeded'],
  // [8, ERRORS.generic],
  // [9, ERRORS.generic],
  // [10, ERRORS.generic],
  // [11, ERRORS.generic],
  // [12, ERRORS.generic],
  [31, ERRORS.failed_3ds],
  // Paymill
  [40103, 'Payment was unsuccessful, since the credit card limit was exceeded']
]);

export default function paymentError(errorCode) {
  const error =
    typeof errorCode === 'number'
      ? ERROR_CODES.get(errorCode)
      : ERRORS[errorCode];
  return error;
}
